import { render, staticRenderFns } from "./SiteLogo.vue?vue&type=template&id=a648a1d6&scoped=true&"
import script from "./SiteLogo.vue?vue&type=script&lang=js&"
export * from "./SiteLogo.vue?vue&type=script&lang=js&"
import style0 from "./SiteLogo.vue?vue&type=style&index=0&id=a648a1d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a648a1d6",
  null
  
)

export default component.exports